
export const navbar = {
  'backoffice.navbar.notifications': 'Bildirimler',
  'backoffice.navbar.language': 'Dil',
  'backoffice.navbar.signIn': 'Giriş Yap'
};
